import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const SectionIntro = ({ title, description, children }) => {
  return (
    <Styles.Container>
      <Styles.Header>
        <Text type="titleM">{title}</Text>
        <Text type="bodyMRegular">{description}</Text>
      </Styles.Header>
      {children}
    </Styles.Container>
  )
}

export default SectionIntro
